import { TokenBody } from '../model/token-body';
import {Injectable} from '@angular/core';
import {ApplicationType, Permission, BuildingProductType} from '../enums/enums';
import {TokenApplication} from '../model/token-application';

@Injectable({
  providedIn: 'root',
})
export class TokenService {

  private token: string;
  private refreshToken: string;
  private decodedToken: TokenBody;

  constructor() { }

  public getToken(): string {
    return this.token;
  }

  public getRefreshToken(): string {
    return this.refreshToken;
  }

  public getLoginId(): number {
    return (this.decodedToken != null) ? this.decodedToken.LoginId : null;
  }

  public getUsername(): string {
    return (this.decodedToken != null) ? this.decodedToken.Username : null;
  }

  public getFirstName(): string {
    return (this.decodedToken != null) ? this.decodedToken.FirstName : null;
  }

  public getLastName(): string {
    return (this.decodedToken != null) ? this.decodedToken.LastName : null;
  }

  public getCulture(): string {
    return (this.decodedToken != null) ? this.decodedToken.Culture : 'en';
  }

  public hasApplication(application: ApplicationType): boolean {
    return this.getApplications().includes(application);
  }

  public getLanguage(): string {
    const culture = this.getCulture();
    const parts = culture.split('-');
    return parts[0].toUpperCase()
  }

  public getCountry(): string {
    return (this.decodedToken != null && this.decodedToken.Country != null) ? this.decodedToken.Country : 'GB';
  }

  public getTokenPermissions() : Permission[] {
    let permissions: Permission[] = [];

    const buildingApp = this.getBuildingApplicationFromApplications();
    if (buildingApp != null) {
      permissions = buildingApp.Permissions || [];
    }

    return permissions;
  }

  public getBusinessProducts(): BuildingProductType[] {
    const buildingApp = this.getBuildingApplicationFromApplications();
    if (buildingApp != null) {
      return buildingApp.Products || [];
    } else {
      return [];
    }
  }

  public getLicenseAgreed(): boolean {
    const buildingApp = this.getBuildingApplicationFromApplications();
    if (buildingApp != null) {
      return buildingApp.LicenseAgreed || false;
    } else {
      return false;
    }
  }

  public getApplications(): ApplicationType[] {
    if (this.decodedToken != null && this.decodedToken.Applications != null) {
      return this.decodedToken.Applications.map(app => app.Type);
    } else {
      return [];
    }
  }

  public setToken(token: string) {
    this.token = token;
    this.decodedToken = this.getDecodedToken();
  }

  public setRefreshToken(token: string) {
    this.refreshToken = token;
  }

  private getDecodedToken(): TokenBody {
    const encodedToken: string = this.token;
    if (encodedToken != null) {
      const tokenParts: string[] = encodedToken.split('.');
      if (tokenParts[1] != null) {
        const decodedTokenJson = decodeURIComponent(Array.prototype.map.call(atob(tokenParts[1]), function(c) {
          return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
        }).join(''));
        return JSON.parse(decodedTokenJson);
      }
    }
    return null;
  }

  private getBuildingApplicationFromApplications(): TokenApplication {
    if (this.decodedToken != null && this.decodedToken.Applications != null) {
      return this.decodedToken.Applications.find(app => app.Type === ApplicationType.BUILDING);
    } else {
      return null;
    }
  }
}
